import { createFragmentContainer, graphql } from "react-relay";
import { AttributeTable, AttributeTableRow } from "~/components/shared/AttributeTable";
import { UserAvatarRelay as UserAvatar } from "~/components/shared/UserAvatar";
import JobEvent from "~/components/JobActivityTimeline/JobEvent";

type Props = {
  event: any;
  previousTimestamp: string | null | undefined;
};

function JobEventReprioritized({ event, previousTimestamp }: Props) {
  const { timestamp, actor, changedPriorityBeforeValue, changedPriorityAfterValue } = event;

  console.log({ actor });

  return (
    <JobEvent timestamp={timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>
        Job reprioritized
        {actor.type === "USER" && actor?.node && (
          <>
            {" by "}
            <UserAvatar className="mr-1" size="MICRO" user={actor.node} suppressAltText={true} />
            {actor.node.name}
          </>
        )}
      </JobEvent.Label>
      <JobEvent.Content>
        <AttributeTable>
          <AttributeTableRow title="Priority">
            <code className="dark-gray monospace">
              {changedPriorityBeforeValue} → <strong>{changedPriorityAfterValue}</strong>
            </code>
          </AttributeTableRow>
        </AttributeTable>
      </JobEvent.Content>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventReprioritized, {
  event: graphql`
    fragment JobEventReprioritized_event on JobEvent {
      ... on JobEvent {
        timestamp

        actor {
          type
          node {
            ... on User {
              name
              uuid
              ...UserAvatar_user
            }
          }
        }

        ... on JobEventReprioritized {
          changedPriorityBeforeValue
          changedPriorityAfterValue
        }
      }
    }
  `,
});
